/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ComponentGridFilter, ComponentRestService } from '@gh/builder-shared-data';
import { getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { getRouteTrackerFilter, SlicedDataSource } from '@gh/core-data';
import { getSlicedDataQueryFromCursorTracker, GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ID } from '@gh/common-shared-data';
import {
  ComponentListCheckUsage,
  ComponentListItem,
  DEFAULT_COMPONENT_FILTER,
} from './component-list-item.model';

@Injectable()
export class ComponentListBusinessService implements InitViewService {

  constructor(private restService: ComponentRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(snapshot: ActivatedRouteSnapshot): any {
    const componentId = getRouteQueryParam(snapshot, 'focusedId');
    const filter = getRouteTrackerFilter<ComponentGridFilter>(snapshot) || DEFAULT_COMPONENT_FILTER;
    const { sorting } = getSlicedDataQueryFromCursorTracker(snapshot);
    return {
      gridLayout: this.gridLayoutService.get('components'),
      componentIndex: componentId && this.restService.getIndex(componentId, filter, sorting),
    };
  }

  findAllAsDataSource(filter: ComponentGridFilter): SlicedDataSource<ComponentListItem> {
    return this.restService.findAllAsDataSource(filter);
  }

  activate(component: ComponentListItem): Observable<ComponentListItem> {
    return this.restService.undelete(component);
  }

  checkUsage(component: ComponentListItem): Observable<ComponentListCheckUsage> {
    return this.restService.checkUsage(component);
  }

  deactivateOrDelete(component: ComponentListItem, checkUsage: ComponentListCheckUsage): Observable<any> {
    return this.restService.deactivateOrDelete(component, checkUsage);
  }
  bulkDelete(items: any[]): Observable<any> {
    return this.restService.bulkDelete(items);
  }

  validate(id: ID): Observable<any> {
    return this.restService.validate(id);
  }
}
